import { faIcon } from "@utils/faIcon"

import { Button, ListInfoGlyph } from "@atoms"

import useTable from "@organisms/Table/Table.context"
import styles from "@organisms/Table/TableEdgeStates/TableEdgeStates.module.scss"

import { CLEAR_SEARCH_EVENT } from "@constants/events"

export default function CardListNoResultsState() {
    const { tabContentName } = useTable()

    const explanation = `There are no ${tabContentName
        .toLowerCase()
        .replace("all", "")
        .replace("&", "or")} to display.`

    return (
        <div className={styles.base}>
            <div className={styles.content}>
                <div className={styles.copyWrap}>
                    <ListInfoGlyph variant="black" icon={faIcon({ name: "eye", style: "solid" })} />
                    <div className={styles.copy}>
                        <h2 className={styles.title}>No results found</h2>
                        <p className={styles.explanation}>{explanation}</p>
                    </div>
                </div>

                <Button
                    size="lg"
                    variant="subtle"
                    onClick={() => {
                        const clearSearchEvent = new CustomEvent(CLEAR_SEARCH_EVENT, {})
                        window.dispatchEvent(clearSearchEvent)
                    }}
                    noDebounce={true}
                >
                    Clear search
                </Button>
            </div>
        </div>
    )
}
